import { qnPrimary, qnGreen, qnOrange, qnPink, qnRed, qnRose, qnTurquoise, qnViolet, qnBlueGrey, qnTeal, qnBlue, qnNeutrals, qnTexts } from './_palette';
import { overrides as components } from '../overrides';

export const sharedThemeOptions = {
  direction: 'ltr',
  spacing: (factor) => `${0.5 * factor}em`,
  mixins: {
    flippedInRtl: (dir) => ({
      transform: dir === 'rtl' ? 'scaleX(-1)' : 'scaleX(1)'
    })
  },
  palette: {
    primary: qnPrimary,
    secondary: {
      main: 'rgb(228,232,253)',
      mainBackup: 'rgb(228,232,253)',
      textIconColor: "rgb(112, 114, 143, 1)",
      textIconColorBackup: "rgb(112, 114, 143, 1)",
     },
    error: qnRose,
    warning: qnOrange,
    success: qnGreen,
    green: qnGreen,
    orange: qnOrange,
    pink: qnPink,
    red: qnRed,
    rose: qnRose,
    turquoise: qnTurquoise,
    violet: qnViolet,
    blueGrey: qnBlueGrey,
    teal: qnTeal,
    blue: qnBlue,
    neutrals: qnNeutrals,
    texts: qnTexts
  },
  breakpoints: {
    values: {
      xs: 0, //0px - 768px
      sm: 769, //0px - 1024px
      md: 1025, //0px - 1280px
      lg: 1281, //0px - 1366px
      xl: 1367, //0px and up
    }
  },
  components
}
